import React from 'react';
import { createGlobalStyle } from 'styled-components';

const BoxRadioComponent = (props: any) => {
  return (
    <div style={props.styleBox}>
      <Styles />
      <input
        type={props.type}
        id={props.id}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        defaultChecked={props.defaultChecked}
      />
      <label htmlFor={props.name} >{props.label}</label>
    </div>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  input[type="radio"] {
    appearance: none;
    background-color: #fff;
    margin: 0;
    font: inherit;
    color: #1157B2;
    width: 1.15em;
    height: 1.15em;
    border: 0.20em solid #1157B2;
    border-radius: 50%;
  }
  input[type="radio"]:checked {
    background-color: white;
    box-shadow: inset 0 0 0 4px #1157B2;
  }
}

`;

export default BoxRadioComponent;
